<template>
  <v-card class="observatory-list" flat>
    <v-row
      no-gutters
      align="center"
      class="py-1 px-2 font-weight-bold"
      style="position:relative; background-color: #dddddd"
    >
      <v-col cols="auto">
        RisKma | 降雪状況一覧
      </v-col>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="orange"
        style="position: absolute; bottom: 0; left: 0"
      ></v-progress-linear>
    </v-row>
    <v-row no-gutters>
      <v-col v-for="ob in snows" :key="ob.id" class="pa-2">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th colspan="4" class="text-center ob">{{ ob.name }}</th>
              </tr>
              <tr>
                <th class="text-left">
                  時間
                </th>
                <th class="text-left">
                  気温
                </th>
                <th class="text-left">
                  時間降雪
                </th>
                <th class="text-left">
                  積雪深
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ts in ob.timeSeries" :key="ts.date">
                <td>{{ toTableFormat(ts.date) }}</td>
                <td>{{ ts.atmospheric_temperature }}</td>
                <td>{{ ts.snow }}</td>
                <td>{{ ts.snow_total }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="6" class="pa-1">
        <v-row no-gutters>
          <v-col v-for="ob in cameras" :key="ob.id" cols="6" class="pa-1">
            <div class="ob pa-1">{{ ob.name }}</div>
            <v-img
              v-if="ob.url"
              :src="ob.url"
              aspect-ratio="1"
              max-height="170px"
              @click="onClickImage(ob)"
            ></v-img>
            <v-card v-else height="170" outlined class="pa-2 caption">
              カメラ調整中...
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-if="bigSizeImageOb" v-model="dialog" max-width="1000px">
      <v-row
        no-gutters
        align="center"
        justify="end"
        style="background-color: white"
      >
        <h3 class="pa-2">{{ bigSizeImageOb.name }}</h3>
        <v-spacer></v-spacer>
        <v-btn depressed @click="dialog = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-row>
      <v-img :src="bigSizeImageOb.url" max-width="1000px"></v-img>
    </v-dialog>
  </v-card>
</template>
<script>
import * as axiosHelper from "@/utils/axiosHelper";
import moment from "moment";
import { OBSERVATORY } from "@/enums/Type";

const DATE_FORMAT = "YYYY/MM/DD HH:mm";
const obGroups = [
  {
    type: OBSERVATORY.SNOW.code,
    ids: [
      { id: "99_17000_3_200065" },
      { id: "99_17000_3_200066" },
      { id: "99_17000_3_200055" }
    ]
  },
  {
    type: OBSERVATORY.CAMERA.code,
    ids: [
      { id: "99_17000_3_135" },
      { id: "99_17000_3_153" },
      { id: "99_17000_3_121" },
      { id: "99_17000_3_51" },
      { id: "99_17000_3_109" },
      { id: "99_17000_3_33" }
    ]
  }
];

export default {
  name: "SnowObservatoryList",
  data() {
    return {
      baseDate: moment().utc(),
      snows: [],
      cameras: [],
      bigSizeImageOb: null,
      dialog: false,
      isLoading: false
    };
  },
  computed: {
    observatories() {
      return this.$store.getters.observatories;
    }
  },
  async created() {
    this.isLoading = true;
    await this.fetchObservatories();

    for (const group of obGroups) {
      const ids = group.ids;
      const type = group.type;

      const array = [];

      for (const item of ids) {
        const id = item.id;
        const ob = this.observatories.find(ob => {
          return ob.id === id && ob.type === type;
        });
        if (ob) {
          let data;
          if (type === OBSERVATORY.SNOW.code) {
            data = await this.fetchData(ob);
          } else if (type === OBSERVATORY.CAMERA.code) {
            data = await this.fetchCameraData(ob);
          }
          if (data) {
            array.push(data);
          }
        }
      }

      if (type === OBSERVATORY.SNOW.code) {
        this.snows = array;
      } else if (type === OBSERVATORY.CAMERA.code) {
        this.cameras = array;
      }
    }

    this.isLoading = false;
  },
  methods: {
    async fetchObservatories() {
      return this.$store.dispatch("FETCH_OBSERVATORIES");
    },
    async fetchData(ob) {
      const params = {
        date: this.baseDate.format(DATE_FORMAT),
        id: ob.id,
        type: ob.type,
        rain_forecast: false
      };
      if (ob.type === OBSERVATORY.SNOW.code) {
        params.hours = 24;
      }
      const response = await axiosHelper.get("/observatories/data", params);
      if (response === null) {
        throw new Error("fetch failed : observatories/data");
      }

      const temp = Object.assign({}, ob);
      temp.timeSeries = response.timeSeries;
      temp.currentDate = this.baseDate
        .subtract(this.baseDate.minute() % 10, "minutes")
        .format(DATE_FORMAT);

      return temp;
    },
    async fetchCameraData(ob) {
      const params = {
        date: this.baseDate.format(DATE_FORMAT),
        id: ob.id,
        type: OBSERVATORY.CAMERA.code,
        rain_forecast: false
      };
      if (ob.dynamodb) {
        params["dynamodb"] = ob.dynamodb;
      }
      if (ob.bucket) {
        params["bucket"] = ob.bucket;
      }
      if (ob.prefix) {
        params["prefix"] = ob.prefix;
      }

      const response = await axiosHelper.get("/observatories/data", params);
      if (response === null) {
        throw new Error("fetch failed : observatories/data");
      }
      const temp = Object.assign({}, ob);
      temp.url = response.timeSeries.length > 0 ? response.timeSeries[response.timeSeries.length - 1].url : null;
      return temp;
    },
    toTableFormat(date) {
      return moment
        .utc(date, DATE_FORMAT)
        .local()
        .format("MM/DD HH:mm");
    },
    onClickImage(ob) {
      this.bigSizeImageOb = ob;
      this.dialog = true;
    }
  }
};
</script>
<style scoped lang="scss">
.ob {
  background-color: #3a1e87;
  color: white !important;
  font-size: 12px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: bold;
}
.observatory-list {
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0 6px;
  }
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    padding: 0 6px;
  }
  .v-image {
    cursor: pointer;
  }
}
</style>
